<template>
  <DialogTemplate
    :contentStretch="true"
    :contentStyle="'margin:0;padding:0!important'"
  >
    <div class="mt-4 px-4">
      <div class="sws-title mt-4">
        {{ $t('switchers.sw_actions_grouping') }}
      </div>
      <div class="d-flex">
        <UnSwitcherNew
          swKey="sw_actions_grouping"
          class="gswtch"
          style="
            background: var(--clr-black-1-3);
            border-radius: 4px;
            --gwbtn-size: 1rem;
            --gwbtn-height: 1.875rem;
            --gwbtns-wrap: wrap;
            --gwbtns-padding: 2px;
          "
          :asMenu="false"
        />
      </div>

      <div class="sws-title mt-4">
        {{
          street === 'flop'
            ? $t('switchers.sw_reports_flop_grouping')
            : $t('switchers.sw_reports_turn_grouping')
        }}
      </div>
      <div class="d-flex">
        <UnSwitcherNew
          :swKey="street === 'flop' ? 'sw_reports_flop_grouping' : 'sw_reports_turn_grouping'"
          class="gswtch"
          style="
            background: var(--clr-black-1-3);
            border-radius: 4px;
            --gwbtn-size: 1rem;
            --gwbtn-height: 1.875rem;
            --gwbtns-wrap: wrap;
            --gwbtns-padding: 2px;
          "
          :asMenu="false"
        />
      </div>

      <div class="sws-title mt-4">
        {{ $t('common.view') }}
      </div>
      <div class="d-flex">
        <UnSwitcherNew
          :swKey="street === 'flop' ? 'sw_reports_flop_content' : 'sw_reports_turn_content'"
          class="gswtch"
          style="
            background: var(--clr-black-1-3);
            border-radius: 4px;
            --gwbtn-size: 1rem;
            --gwbtn-height: 1.875rem;
            --gwbtns-wrap: wrap;
            --gwbtns-padding: 2px;
          "
          :asMenu="false"
        />
      </div>

      <div
        v-if="
          street === 'flop'
            ? $store.getters.sw_reports_flop_content === 'swv_flop_table'
            : $store.getters.sw_reports_turn_content === 'swv_turn_table'
        "
        class="f-column"
      >
        <div class="sws-title mt-4">{{ $t('common.highlight') }}:</div>
        <div class="d-flex">
          <UnSwitcherNew
            class="gswtch mr-auto"
            swKey="sw_reports_colorcoding01"
            style="
              background: var(--clr-black-1-3);
              border-radius: 4px;
              --gwbtn-size: 1rem;
              --gwbtn-height: 1.875rem;
              --gwbtns-wrap: wrap;
              --gwbtns-padding: 2px;
            "
            :asMenu="false"
          />
        </div>
      </div>

      <div class="sws-title mt-4">
        {{ $t('settings.show_bets_in') }}
      </div>
      <SettingsBetInPercent
        :hasTitle="false"
        :hasKey="false"
        :hasPreview="false"
      />

      <div class="sws-title mt-4">
        {{ $t('settings.show_ev_in') }}
      </div>
      <SettingsEvIn
        :hasPreview="false"
        :hasTitle="false"
        :hasKey="false"
      />
    </div>

    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        @click.stop="$store.dispatch('router_reset_dialogs')"
        >{{ $t('btn.close') }}</v-btn
      >
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
import SettingsBetInPercent from '@/components/Dialogs/UserSettingsDialog/SettingsBetInPercent'
import SettingsEvIn from '@/components/Dialogs/UserSettingsDialog/SettingsEvIn'

export default {
  name: 'StudyReportsViewDialog',
  components: {
    UnSwitcherNew,
    SettingsBetInPercent,
    SettingsEvIn,
    DialogTemplate,
  },
  props: {},
  computed: {
    street() {
      return this.$store.getters.street
    },
  },
}
</script>

<style lang="scss" scoped>
.sws-title {
  font-size: 0.875rem;
  color: var(--clr-grey-2);
  margin-bottom: 0.5rem;
}
</style>
